import PropTypes from 'prop-types'
import {Flex, Text, Box} from '@chakra-ui/react'

import {useTranslation} from 'react-i18next'

const StepDisplay = ({currentStepId, steps}) => {
  const {t} = useTranslation('invoiceEmailTemplates')
  const currentStepObj = steps.find((step) => step.id === currentStepId)
  const currentStepIndex = currentStepObj?.id || 1
  const totalSteps = steps.length
  const isLastStep = currentStepIndex === totalSteps

  return (
    <Flex direction="column" width="full" pb={2}>
      {!isLastStep && (
        <Flex direction="column" gap={1}>
          <Flex direction="row" gap={2}>
            <Text
              color="mld.neutral.200"
              fontSize="sm"
              fontWeight="medium"
              textTransform="uppercase"
              lineHeight="110%"
              mb={2}
            >
              {t('step', {step: currentStepIndex})}
            </Text>
            <Text
              color="mld.neutral.200"
              fontSize="sm"
              fontWeight="regular"
              textTransform="uppercase"
              lineHeight="110%"
              mb={2}
            >
              {t(`steps.${currentStepObj?.currentStep}Label`)}
            </Text>
          </Flex>
          <Flex direction="row" gap={1} width="full">
            {steps.slice(0, -1).map((step) => (
              <Box
                key={step.id}
                flex="1"
                height="6px"
                bg={
                  step.id <= currentStepIndex
                    ? 'mld.progress.primary.500'
                    : 'mld.neutral.800'
                }
                borderRadius="full"
              />
            ))}
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}

StepDisplay.propTypes = {
  currentStepId: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nextStep: PropTypes.string,
      currentStep: PropTypes.string.isRequired,
      previousStep: PropTypes.string,
    }),
  ).isRequired,
}

export default StepDisplay
